<script>

</script>


<div class="divider"></div>

<div id="bio" class="section">         

            <!-- <h4 class="blue-grey-text text-lighten-2">Short bio</h4> -->
            <p class="flow-text"><span class="strong">Super Short Bio -</span> I was born and raised in Guadalajara, Mexico but I've been living abroad for almost 2 decades. In the late 90's, my childhood hobby turned into a profession when I got contracted to create illustrations for an American editorial publication based in Las Vegas, NV. After graduating high school I decided to pursue a career in Fine Arts and got enrolled in the <a href="http://www.cuaad.udg.mx/" target="_blank" rel="noreferrer">University of Guadalajara</a> for a Bachelor's Degree in Visual Arts for Plastic Expression (<em>painting, printmaking, sculpture and photography</em>).</p>


</div>



<style>
    .divider{background-color: #90a4ae78;}
    .section {background-color: transparent !important;}

    @media screen and (min-width: 400px) {
        .flow-text { font-size: 1.2em; }
    }

</style>